import { render, staticRenderFns } from "./sender.vue?vue&type=template&id=deea9370&scoped=true&"
import script from "./sender.vue?vue&type=script&lang=js&"
export * from "./sender.vue?vue&type=script&lang=js&"
import style0 from "./sender.vue?vue&type=style&index=0&id=deea9370&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deea9370",
  null
  
)

export default component.exports